import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LieuRepository } from '@domain/lieu/lieu.repository';
import { Lieu } from '@domain/lieu/lieu';
import { TypeLieu } from '@domain/lieu/type-lieu';
import { LieuResponseDto } from '../dtos/lieu/lieu.response.dto';
import { TypeLieuDto } from '../dtos/lieu/type-lieu.dto';
import { LieuMapper } from '../mappers/lieu.mapper';

@Injectable()
export class LieuHttpRepository extends LieuRepository {
  private readonly baseUrl = `${environment.apiUrl}/lieux`;
  private readonly typesUrl = `${environment.apiUrl}/lieuTypes`;

  constructor(private readonly http: HttpClient) { super(); }

  getAll(): Observable<Lieu[]> {
    return this.http.get<LieuResponseDto[]>(this.baseUrl).pipe(
      map(dtos => (dtos ?? []).map(dto => LieuMapper.fromDto(dto)))
    );
  }

  getTypeLieux(): Observable<TypeLieu[]> {
    return this.http.get<TypeLieuDto[]>(this.typesUrl).pipe(
      map(dtos => dtos.map(dto => LieuMapper.typeLieuFromDto(dto)))
    );
  }

  create(lieu: Lieu): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}`, LieuMapper.toRequestDto(lieu));
  }

  update(lieu: Lieu): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${lieu.id}`, LieuMapper.toRequestDto(lieu));
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
